import { format, isToday, isTomorrow } from 'date-fns'
import { TimeProps } from './commonTypes'
import { Medium } from '../../common'
import { FulfillmentPrefix } from './commonStyles'

export const ScheduledTime = ({ from, to, variant }: TimeProps) => {
  const fromTime = format(from, 'HH:mm')
  const toTime = format(to, 'HH:mm')
  const dateFormat =
    variant === 'list'
      ? format(from, 'EEEE do MMMM')
      : format(from, 'EEEE do MMM')

  let fulfillmentParticle = ''
  let fulfillmentDay

  if (isToday(from)) {
    fulfillmentDay = 'Today'
  } else if (isTomorrow(from)) {
    fulfillmentDay = 'Tomorrow'
  } else {
    fulfillmentParticle = 'on '
    fulfillmentDay = dateFormat
  }

  return (
    <>
      {variant === 'list' ? (
        <span style={{ color: '#595959' }}>
          {fulfillmentParticle}
          {fulfillmentDay}
          <> from </>
          {fromTime} - {toTime}
        </span>
      ) : (
        <>
          <FulfillmentPrefix>{fulfillmentDay}</FulfillmentPrefix>
          <Medium>
            {fromTime} - {toTime}
          </Medium>
        </>
      )}
    </>
  )
}
